// ============================================
// ENGLISH TRANSLATIONS
// ============================================

export const en = {
    // Common selects
    selectCountry: '-- Select Country --',
    selectState: '-- Select State --',
    select: '-- Select --',

    // Add more translations as needed
} as const;
